<script>
	// import { onMount } from 'svelte'
	import { fade, fly, slide } from 'svelte/transition'
	import { sineInOut } from 'svelte/easing'

	export let header = ''
	export let tabs

	let content = ''
	// if (content.length) {
	// 	let pattern = /(\\|\n)/
	// 	//content = content.replace(pattern, '')
	// }
	if (header.length && typeof header == 'string') header = JSON.parse(header)
	if (tabs.length && typeof tabs == 'string') tabs = JSON.parse(tabs)

	let idx = 0
	let tabcontent = tabs[idx].content
</script>

<!-- <style type="text/scss">
	.inner-wrap {
		display: flex;
		flex-flow: column;
		align-items: center;
		padding: 0 !important;
	}
	.tabs {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		width: 100%;
	}

	$split: 54%;
	$length: 3vw;
	$space: 1vw;
	.col {
		width: calc(100% - #{$split} - (#{$length} / 2 + #{$space}));
		h3 {
			color: #121212;
			text-align: right;
			position: relative;
			font-weight: 400;
			transition: 0.1s;
			font-size: 26px;
			cursor: pointer;

			display: flex;
			//flex-flow: column;
			justify-content: flex-end;
			span {
				display: none;
			}
		}
		.active {
			transition: 0.1s;
			color: #831428 !important;
			font-weight: 700;
			&:after {
				content: '';
				position: absolute;
				top: 50%;
				left: calc(100% + #{$space});
				width: $length;
				border-bottom: 3px solid #831428;
			}
		}
	}
	.small-container {
		display: none;
	}
	.tab-content {
		width: calc(#{$split} - (#{$length} / 2 + #{$space}));
		height: 100%;
		margin-top: -0.45em;
		//TODO prevent varying height due to content
		ul {
			padding-left: 1.2em;
		}
	}
	li {
		font-size: 20px;
	}
	// @media screen and (min-width: 768px) {
	// 	// .page-template-services {
	// 	// 	.tabs {
	// 	// 		.col {
	// 	// 			width: calc(40% - 2vw)!important;
	// 	// 		}
	// 	// 		.tab-content {
	// 	// 			width: calc(60% - 2vw)!important;
	// 	// 		}
	// 	// 	}
	// 	// }
	// }
	@media screen and (max-width: 767px) {
		h3 {
			span {
				//display: none;
				display: inline-block !important;
				margin-top: -1%;
				margin-left: 2%;
			}
		}
		:not(.active) span {
			display: inline-block;
		}

		.chevron-open {
			margin-top: 0.5%;
		}
		.tab-content {
			display: none !important;
		}
		.small-container {
			display: block;
		}

		.col {
			width: 100%;
			h3 {
				text-align: center;
				justify-content: center;
				margin-bottom: 1rem !important;
			}
		}
		.active:after {
			content: unset !important;
		}
	}
</style> -->

<section>
	<div class="main">
		<div class="inner-wrap">
			{@html header}
			{@html content}
			<div class="tabs">
				<div class="col">
					{#each tabs as tab, i}
						<h3
							id={tab.label}
							class={i == idx ? 'active' : ''}
							on:mouseover={() => {
								if (!window.matchMedia('(max-width: 767px)').matches) {
									idx = i
								}
							}}
							on:click={() => {
								if (window.matchMedia('(max-width: 767px)').matches) {
									if (idx != i) {
										idx = i
									} else {
										idx = -1
									}
								}
							}}>
							{tab.label}
							<span class="chevron-close">&#8964</span>
							<!-- {#if idx != i}
							{:else}
								<span class="chevron-open">&#8963</span>
							{/if} -->
						</h3>
						<!-- mobile version -->
						{#if i == idx}
							<div
								class="small-container"
								transition:slide={{ delay: 50, duration: 200 }}>
								{@html tab.content}
							</div>
						{/if}
					{/each}
				</div>
				<!-- desktop version -->
				<div class="tab-content">
					{#each tabs as tab, i}
						{#if i == idx}
							<div key={tab.label}>
								{@html tab.content}
							</div>
						{/if}
					{/each}
				</div>
			</div>
		</div>
	</div>
</section>
